import { type ReactNode } from 'react';

export type SuitKind = 'spades' | 'hearts' | 'diamonds' | 'clubs';

export function SuitGlyph({ suit, className = 'size-5' }: { suit: SuitKind; className?: string }) {
  const colorClass = suit === 'hearts' || suit === 'diamonds' ? 'text-destructive' : 'text-foreground';
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true" className={`${className} ${colorClass} fill-current shrink-0`}>
      {suit === 'spades' && (
        <path d="M12 2.5C8 7.3 4 10.6 4 14.5c0 2.5 1.9 4.4 4.3 4.4 1.2 0 2.2-.5 2.9-1.3-.2 1.6-.7 2.8-1.7 3.9h5c-1-1.1-1.5-2.3-1.7-3.9.7.8 1.7 1.3 2.9 1.3 2.4 0 4.3-1.9 4.3-4.4 0-3.9-4-7.2-8-12Z" />
      )}
      {suit === 'hearts' && (
        <path d="M12 20.8C10.5 19.6 3.5 14.3 3.5 8.8 3.5 5.8 5.8 3.5 8.6 3.5c1.6 0 3.1.8 3.4 2.1.3-1.3 1.8-2.1 3.4-2.1 2.8 0 5.1 2.3 5.1 5.3 0 5.5-7 10.8-8.5 12Z" />
      )}
      {suit === 'diamonds' && <path d="M12 2.5 20 12l-8 9.5L4 12 12 2.5Z" />}
      {suit === 'clubs' && (
        <path d="M12 3.2a3.8 3.8 0 0 0-3.8 3.8c0 1.3.6 2.4 1.6 3.1a3.9 3.9 0 0 0-5.3 3.6A3.8 3.8 0 0 0 8.3 17.5c1.1 0 2.1-.5 2.8-1.2-.2 1.7-.7 3.1-1.6 4.5h5c-.9-1.4-1.4-2.8-1.6-4.5.7.7 1.7 1.2 2.8 1.2a3.8 3.8 0 0 0 3.8-3.8 3.9 3.9 0 0 0-5.3-3.6c1-.7 1.6-1.8 1.6-3.1A3.8 3.8 0 0 0 12 3.2Z" />
      )}
    </svg>
  );
}

export function MiniPlayingCard({
  rank,
  suit,
  showBottomPip = true,
  className = '',
}: {
  rank: string;
  suit: SuitKind;
  showBottomPip?: boolean;
  className?: string;
}) {
  const colorClass = suit === 'hearts' || suit === 'diamonds' ? 'text-destructive' : 'text-foreground';
  return (
    <div
      className={`flex h-11 w-8 shrink-0 flex-col justify-between rounded-[5px] border border-border bg-background p-1 shadow-xs select-none ${className}`}
    >
      <div className="flex flex-col items-start gap-0.5 leading-none">
        <span className={`text-[9px] leading-none font-bold tracking-tighter ${colorClass}`}>{rank}</span>
        <SuitGlyph suit={suit} className="size-2.5" />
      </div>
      {showBottomPip && (
        <div className="flex items-center justify-end">
          <SuitGlyph suit={suit} className="size-3" />
        </div>
      )}
    </div>
  );
}

export function CardVignette({ children }: { children: ReactNode }) {
  return (
    <div
      aria-hidden="true"
      className="relative flex h-14 w-16 shrink-0 items-center justify-center rounded-xl border border-border/80 bg-muted/40"
    >
      {children}
    </div>
  );
}
